// extracted by mini-css-extract-plugin
export default {"header":"Modal_header__vpOwx","title":"Modal_title__RcBLb","content":"Modal_content__InD23","actions":"Modal_actions__xHv7-"};